<script lang="ts">
  import { link } from "svelte-spa-router";
</script>

<div class="panel p-8 text-center">
  <h1 class="text-xl font-semibold mb-2">Page not found</h1>
  <p class="text-text-muted mb-4">No route matches that URL.</p>
  <a use:link href="/" class="btn">Back to playbook</a>
</div>
